import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { ChefHat, Lock } from 'lucide-react';
import { toast } from 'sonner';

const Login = () => {
  const [pin, setPin] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleLogin = () => {
    if (login(pin)) {
      toast.success('Login successful!');
      navigate('/');
    } else {
      toast.error('Invalid PIN code');
      setPin('');
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleLogin();
    }
  };

  return (
    <div className="min-h-screen bg-[#09090B] flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="flex items-center justify-center gap-3 mb-4">
            <ChefHat className="w-12 h-12 text-[#22C55E]" />
          </div>
          <h1 className="text-3xl font-bold font-mono text-[#FAFAFA] mb-2">Buffet OS</h1>
          <p className="text-[#A1A1AA] text-sm">Reservation Management System</p>
        </div>

        {/* Login Card */}
        <div className="glass-card p-8 rounded-lg neon-border">
          <div className="mb-6">
            <div className="flex items-center gap-2 mb-4">
              <Lock className="w-5 h-5 text-[#22C55E]" />
              <h2 className="text-xl font-semibold text-[#FAFAFA]">Staff Login</h2>
            </div>
            <p className="text-sm text-[#A1A1AA]">Enter your PIN code to access the system</p>
          </div>

          <div className="space-y-4">
            <div>
              <Input
                data-testid="pin-input"
                type="password"
                placeholder="Enter PIN"
                value={pin}
                onChange={(e) => setPin(e.target.value)}
                onKeyPress={handleKeyPress}
                maxLength={4}
                className="bg-[#09090B] border-[#27272A] text-[#FAFAFA] text-center text-2xl tracking-widest"
                autoFocus
              />
            </div>

            <Button
              data-testid="login-button"
              onClick={handleLogin}
              disabled={pin.length !== 4}
              className="w-full bg-[#22C55E] hover:bg-[#22C55E]/90 shadow-[0_0_10px_rgba(34,197,94,0.2)] py-6 text-lg"
            >
              Login
            </Button>
          </div>
        </div>

        <p className="text-center text-xs text-[#A1A1AA] mt-6">
          Buffet des Continents © 2025
        </p>
      </div>
    </div>
  );
};

export default Login;
